import { requests } from '../helper/Agent';

export default class OfferingApi {
  static getOfferts() {
    return requests.get('/offerings');
  }
  static getOffertByQuotation(id) {
    return requests.get(`/offerings/quotation/${id}`);
  }
  static getMyOfferts(id) {
    return requests.get(`/offerings/me/?quotation=${id}`);
  }
  static createOffert(data) {
    return requests.post('/offerings', data);
  }
  static updateOffert(id, data) {
    return requests.put(`/offerings/${id}`, data);
  }
  static removeOffertById(id) {
    return requests.del(`/offerings/${id}`);
  }
}